import React from 'react';
import { Document } from '@contentful/rich-text-types';
import { RichText } from '../../richText';

interface CaseStudyStatsProps {
  introduction: Document;
  statItems: StatItem[];
}

interface StatItem {
  statistic: string;
  description: string;
}

export const CaseStudyStats: React.FC<CaseStudyStatsProps> = ({
  introduction,
  statItems,
}) => {
  return (
    <div className="relative w-full py-32 border-t border-b border-black cs-bordered">
      <span className="absolute top-0 left-0 w-1/2 h-full border-r border-black" />

      <div className="relative w-3/4 p-8 mx-auto border border-black md:p-24 md:pb-16 md:max-w-3xl bg-neutral">

        <div className="text-center">
          <RichText content={introduction} />
        </div>

        <div className="pt-12 text-center">

          {statItems && statItems.map((statItem, index) =>
          (
            <div key={`StatItem-${index}`} className="mb-8">
              <p className="mb-4 text-4xl md:text-6xl">{statItem.statistic}</p>
              <p className="text-lg md:text-2xl">{statItem.description}</p>
            </div>
          ),
          )}
        </div>

      </div>

    </div>
  );
};
